import { isEmpty } from 'underscore';
import http from 'hub-http/clients/apiClient';
// @ts-expect-error untyped file
import { getFormDraftKey } from '../earlyRequest/earlyRequestsShared';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped file
import { ER_EDITOR_ALIAS } from 'FormsCommonComponents/earlyRequest/earlyRequestKeys';
const BASE_URL = '/forms/v2/forms-drafts';
function _fetchFormWithDraft(guid) {
  return http.get(`${BASE_URL}/${guid}`);
}
export function getFormWithDraft(guid) {
  return getFromEarlyRequest(getFormDraftKey(guid), () => _fetchFormWithDraft(guid), {
    alias: ER_EDITOR_ALIAS
  });
}
export function publishAndDeleteDraft(guid, formDefinition) {
  return http.put(`${BASE_URL}/publish/${guid}`, {
    data: formDefinition
  });
}
export function saveFormDraft(guid, formDefinition, knownUpdatedAt) {
  if (isEmpty(formDefinition)) {
    return Promise.reject(new Error('Form definition was empty when saving form draft was attempted'));
  }
  return http.put(`${BASE_URL}/save/${guid}?knownUpdatedAt=${knownUpdatedAt}`, {
    data: formDefinition
  });
}
export function patchFormDraft(guid, formDefinition) {
  return http.patch(`${BASE_URL}/save/${guid}`, {
    data: formDefinition
  });
}
export function deleteFormDraft(guid) {
  return http.delete(`${BASE_URL}/${guid}`);
}